import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-vehicles-selection',
  templateUrl: './user-vehicles-selection.component.html',
  styleUrls: ['./user-vehicles-selection.component.scss'],
})
export class UserVehiclesSelectionComponent  implements OnInit {

  constructor(
    private _router: Router
  ) { }

  ngOnInit() {}

  onSubmit(){
    this._router.navigate(['/user-trip-review']);
  }

}
